import React from 'react';
import Heading from '../../heading/heading';
import Footer from '../../footer/footer';
import './plots.css';
import {Carousel, CarouselItem} from 'react-bootstrap'

function Plots () {

    return (
        <div>
      <Heading />

 <div className='plots_page_content'>
{/* <div className='plots_page_black_background'>
   <p className='plots_page_text'>
     We are Provide Best DTCP Approval Plots for your Dream House. And Also Plots will be highly Nature place and out of the cities. Near you can get the high faciliaities from the cities. You can get Easy Avaliable from Hospitals, Hotels, Malls, Parks, Airport and Bus stand etc.. Hurry book now. contact us for more information.
     </p> 
</div> */}

   <Carousel>

<CarouselItem>
  <div className="sp_Carousel_image Carousel_sp_one ">
     <div className="sp_Carousel_black_background"></div>
  </div>
<Carousel.Caption>
<h3 className='sp_carousel_heading'>
Approval Layout Plots With Compound
  </h3>
<p className='sp_carousel_caption'> 
We are Provide Compound, roads, garden, home facilities and service for Approval plots. And also provide home loan facilities for your house. contact for more information.
</p>
</Carousel.Caption>
</CarouselItem>

<CarouselItem>
  <div className="sp_Carousel_image Carousel_sp_two">
  <div className="sp_Carousel_black_background"></div>
     
  </div>
<Carousel.Caption>
<h3 className='sp_carousel_heading'>
 Plots with Naturals
  </h3>
<p className='sp_carousel_caption'>And Also Plots will be highly Nature place and out of the cities. Near you can get the high faciliaities from the cities.feel free to contact us.
</p>
</Carousel.Caption>
</CarouselItem>

<CarouselItem>
  <div className="sp_Carousel_image  Carousel_sp_three">
  <div className="sp_Carousel_black_background"></div>
     
  </div>
<Carousel.Caption>
<h3 className='sp_carousel_heading'>
DTPC Approval
  </h3>
<p className='sp_carousel_caption'>
We are Provide Best DTCP Approval Plots for your Dream House. Just contact us for more info.
</p>
</Carousel.Caption>
</CarouselItem>

<CarouselItem>
  <div className="sp_Carousel_image  Carousel_sp_four">
  <div className="sp_Carousel_black_background"></div>
     
  </div>
<Carousel.Caption>
<h3 className='sp_carousel_heading'>
 Save Your Money
  </h3>
<p className='sp_carousel_caption'>We will provide Best Customer Service and support. If you want to Save your money Just contact us for more info.
</p>
</Carousel.Caption>
</CarouselItem>


  </ Carousel>


 </div>
      <Footer />
        </div>
        
    )
}

export default Plots;